import Quill from 'quill/core';

const Parchment = Quill.import('parchment');
const { ClassAttributor } = Parchment;

class SoftBreak extends ClassAttributor {
  value(node: HTMLElement) {
    return !!super.value(node);
  }
}

export default new SoftBreak('soft', 'ql-soft', {
  scope: Parchment.Scope.BLOCK_ATTRIBUTE,
});
